import { MarkdownReact } from "@/components/MarkdownReact";

interface CoverLetterBlockProps {
  coverLetterMarkdown: string | null | undefined;
  enableCoverLetter?: boolean;
  logoUrl?: string | null;
  orgName?: string | null;
}

/**
 * Renders cover letter markdown content at the front of a public quote template.
 * Returns null when cover letters are disabled or no content is present.
 * Optionally displays the organization logo in the top-left corner.
 * @param coverLetterMarkdown - The markdown content to render
 * @param enableCoverLetter - Whether cover letters are enabled for this quote
 * @param logoUrl - Optional URL for the organization logo
 * @param orgName - Optional organization name for the logo alt text
 */
export function CoverLetterBlock({
  coverLetterMarkdown,
  enableCoverLetter,
  logoUrl,
  orgName,
}: CoverLetterBlockProps) {
  if (!enableCoverLetter || !coverLetterMarkdown) {
    return null;
  }

  return (
    <div
      className="prose prose-sm max-w-none text-gray-800"
      style={{ breakAfter: "page", pageBreakAfter: "always" }}
    >
      {logoUrl && (
        <img
          src={logoUrl}
          alt={orgName ? `${orgName} logo` : "Company logo"}
          className="h-12 w-auto object-contain not-prose mb-4"
        />
      )}
      <MarkdownReact>{coverLetterMarkdown}</MarkdownReact>
    </div>
  );
}
